import styled from "styled-components";

/**
 * Wrapper do componente FlightSegment
 * Organiza o layout principal para exibir os detalhes do voo.
 */
export const StyledFlightSegment = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

/**
 * Wrapper dos detalhes do segmento
 * Contém informações como data, horários e aeroportos.
 */
export const SegmentDetails = styled.div`
  margin-left: ${({ theme }) => theme.spacing(2)};
  /* gap: ${({ theme }) => theme.spacing(4)}; */
  position: relative;
  align-items: center;
  flex-direction: row;
  display: flex;
  width: 100%;
  justify-content: space-around;

  & > svg {
    color: ${({ theme }) => theme.colors.mediumBlue};
    stroke: ${({ theme }) => theme.colors.mediumBlue};
    stroke-width: 1;

    position: absolute;
    left: ${({ theme }) => theme.spacing(-3)};
    top: ${({ theme }) => theme.spacing(2.5)};
  }
`;

export const FlightIconBlock = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
`;

/**
 * Bloco de data do voo
 * Exibe a data e o dia da semana.
 */

export const FlightDateBlock = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
`;

/**
 * Bloco de informações do voo
 * Contém horários e códigos de aeroportos.
 */
export const FlightInfoBlock = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
`;

/**
 * Wrapper do trajeto do voo
 * Agrupa as informações de partida, chegada e status.
 */
export const FlightPath = styled.div`
  padding: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: center;
  flex-direction: row;
  display: flex;
`;

/**
 * Bloco de status do voo
 * Exibe paradas, duração e outros detalhes.
 */
export const FlightStatus = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;

  & > span {
    margin-bottom: ${({ theme }) => theme.spacing(-0.85)};
    margin-left: ${({ theme }) => theme.spacing(-1.25)};
    margin-top: ${({ theme }) => theme.spacing(-0.5)};
  }
`;
